import React, { Component } from 'react';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../../AppInsights';
import { withMsal, MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { msalInstance } from '../../App';
import BreadCrumbComponent from '../bread-crumb/BreadCrumbComponent';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InboundActivityService } from './InboundActivityService';
import { AdminService } from '../admin/AdminService';
import { Checkbox } from 'primereact/checkbox';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Tooltip } from 'primereact/tooltip';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import AlertMessage from "../alertmessage/AlertMessage";
import { MessageSeverity } from 'primereact/api';
import "./InboundActivityComponent.css";
import Spinner from '../Spinner'
import { weekdays } from 'moment/moment';
import { MultiSelect } from 'primereact/multiselect';

class InboundDetailsComponent extends Component {
    constructor(props) {
        super(props);
        this._isIssueDetailsMounted = false;
        this.state = {
            hideSpinner: false,
            inboundMetricPayload: {
                Id: 0,
                System: null,
                Instance: null,
                Namespace: null,
                TimeCollected: null,
                InterfaceName: null,
                NumMessages: 0,
                LastInboundTimeStamp: null,
                CurrentFrequencyInSeconds: 0,
                CurrentFrequency: null,
                InactivityTimeout: 0,
                ExpectedFrequency: null,
                IsBackloadService: false,
                IsAnomaly: false,
                Decommissioned: false,
                Comments: null,
                IsReviewed: false,
                EditReason: null,
                //HDO-8048
                BizHrsInactivityTimeout: 0,
                OffHrsInactivityTimeout: 0,
                BizHoursFrequency: null,
                OffHoursFrequency: null,
                Starthour: null,
                Endhour: null,
                DayOfWeek: []
            },
            inboundMetricDetails: [],
            inboundMetricUpdateLogs: [],
            showInboundMetricUpdateLogs: false,
            pageSuccessMessage: null,
            pageErrorMessage: null,
            actionCommentPanelCollasped: true,
            showpagination: false,
            statusData: null,
            hourValues: Array.from({ length: 24 }, (_, i) => ({
                label: String(i).padStart(2, '0') + ':00',
                value: i
            })),
            weekdayValues: [
                { label: 'Sunday', value: 1 },
                { label: 'Monday', value: 2 },
                { label: 'Tuesday', value: 3 },
                { label: 'Wednesday', value: 4 },
                { label: 'Thursday', value: 5 },
                { label: 'Friday', value: 6 },
                { label: 'Saturday', value: 7 }
            ]
        };
        this.inboundActivityService = new InboundActivityService();
        this.adminService = new AdminService();
    }

    componentDidMount() {
        this._isIssueDetailsMounted = true;
        this.getAdminRoles();
        this.loadInboundMetricDetails()
    }

    getAdminRoles = () => {
        this.adminService.getAdminRoles(this.props.msalContext).then(
            (d) => {
                this.setState({ adminRoles: d, pageErrorMessage: null });
            }
        ).catch(e => {
            console.log(e)
        });
    }

    getRoleId = () => {
        var adminRoles = this.state.adminRoles;
        if (adminRoles && adminRoles.length > 0) {
            switch (true) {
                case adminRoles.includes('SuperAdmin'):
                case adminRoles.includes('Admin'):
                    return 1;
                default:
                    return 0;
            }
        }
        return 0;
    }

    loadInboundMetricDetails = () => {
        this.setState({ pageSuccessMessage: null, pageErrorMessage: null, pageErrorMessage: null })
        this.inboundActivityService.getInboundDataById(this.props.match.params.id, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.' });
                } else if (d.status === 200) {
                    if (this._isIssueDetailsMounted) {
                        this.setState({ inboundMetricDetails: d.body, hideSpinner: true });
                        this.handleInboundDetailsEdit()
                    }
                }
            }
        ).catch(e => {
            this.setState({ hideSpinner: true, pageErrorMessage: 'Something went wrong !!!' })
            console.log(e)
        });
    }

    getMetricThresholdByLatestId = () => {
        this.setState({ hideSpinner: false, pageSuccessMessage: null, pageErrorMessage: null, pageErrorMessage: null })
        this.inboundActivityService.getMetricThresholdByLatestId(this.props.msalContext, this.state.inboundMetricDetails[0].Id).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.' });
                } else if (d.status === 200) {
                    if (this._isIssueDetailsMounted) {
                        this.setState({
                            inboundMetricPayload: {
                                ...this.state.inboundMetricPayload, //using spread operator to initialize object with existing props
                                BizHrsInactivityTimeout: d.body.BizHrsInactivityTimeout || 0,
                                OffHrsInactivityTimeout: d.body.OffHrsInactivityTimeout || 0,
                                BizHoursFrequency: this.formatSeconds(d.body.BizHrsInactivityTimeout) || null,
                                OffHoursFrequency: this.formatSeconds(d.body.OffHrsInactivityTimeout) || null,
                                Starthour: d.body.Starthour,
                                Endhour: d.body.Endhour,
                                DayOfWeek: d.body.DayOfWeek || []
                            },
                            hideSpinner: true, EditInboundVisible: true
                        });
                    }
                }
                this.handleInboundDetailsEdit(true);
            }
        ).catch(e => {
            this.setState({ hideSpinner: true, pageErrorMessage: 'Something went wrong !!!' })
            console.log(e)
        });
    }

    handleViewHistoryChange = () => {
        this.setState({ hideSpinner: false, pageSuccessMessage: null, pageErrorMessage: null })
        this.inboundActivityService.getInboundMetricUpdatelogs(this.props.match.params.id, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.' });
                } else if (d.status === 200) {
                    if (this._isIssueDetailsMounted) {
                        this.setState({ inboundMetricUpdateLogs: d.body, hideSpinner: true, showInboundMetricUpdateLogs: true });
                        if (this.state.inboundMetricUpdateLogs.length > 10) {
                            this.setState({ showpagination: true })
                        }
                    }
                }
            }
        ).catch(e => {
            this.setState({ hideSpinner: true, pageSuccessMessage: null, pageErrorMessage: 'Something went wrong !!!' })
            console.log(e)
        });
    }

    handleInboundDetailsEdit = (IsEdit = false) => {
        if (this.state.inboundMetricDetails.length === 0) {
            this.setState({ pageErrorMessage: 'No data found to edit.' });
            return;
        }
        this.setState({
            inboundMetricPayload: {
                ...this.state.inboundMetricPayload,
                EditReason: '',
                Id: this.state.inboundMetricDetails[0].Id,
                System: this.state.inboundMetricDetails[0].System,
                Instance: this.state.inboundMetricDetails[0].Instance,
                Namespace: this.state.inboundMetricDetails[0].Namespace,
                TimeCollected: this.state.inboundMetricDetails[0].TimeCollected,
                InterfaceName: this.state.inboundMetricDetails[0].InterfaceName,
                NumMessages: this.state.inboundMetricDetails[0].NumMessages,
                LastInboundTimeStamp: this.state.inboundMetricDetails[0].LastInboundTimeStamp,
                CurrentFrequencyInSeconds: this.state.inboundMetricDetails[0].CurrentFrequencyInSeconds,
                CurrentFrequency: this.state.inboundMetricDetails[0].CurrentFrequency,
                InactivityTimeout: this.state.inboundMetricDetails[0].InactivityTimeout,
                IsBackloadService: this.state.inboundMetricDetails[0].IsBackloadService || false,
                IsAnomaly: this.state.inboundMetricDetails[0].IsAnomaly || false,
                Comments: this.state.inboundMetricDetails[0].Comments,
                LastReviewedBy: this.state.inboundMetricDetails[0].LastReviewedBy,
                LastReviewedDateTime: this.state.inboundMetricDetails[0].LastReviewedDateTime,
                IsReviewed: this.state.inboundMetricDetails[0].IsReviewed || false,
                Decommissioned: this.state.inboundMetricDetails[0].Decommissioned || false,
            },
            EditInboundVisible: IsEdit
        });
    }

    handleInputChange = (event) => {
        this.setState({ pageErrorMessage: null, pageSuccessMessage: null })
        if (event.target.name === "BizHrsInactivityTimeout" || event.target.name === "OffHrsInactivityTimeout") {
            if (event.target.name === "BizHrsInactivityTimeout")
                this.setState({
                    inboundMetricPayload: {
                        ...this.state.inboundMetricPayload, //using spread operator to initialize object with existing props
                        [event.target.name]: parseInt(event.target.value, 10),
                        ["BizHoursFrequency"]: this.formatSeconds(event.target.value)
                    }
                })
            else if (event.target.name === "OffHrsInactivityTimeout")
                this.setState({
                    inboundMetricPayload: {
                        ...this.state.inboundMetricPayload, //using spread operator to initialize object with existing props
                        [event.target.name]: parseInt(event.target.value, 10),
                        ["OffHoursFrequency"]: this.formatSeconds(event.target.value)
                    }
                })
        }
        else if (event.target.name === "IsBackloadService" || event.target.name === "IsReviewed"
            || event.target.name === "Decommissioned" || event.target.name === "IsAnomaly") {
            this.setState({
                inboundMetricPayload: {
                    ...this.state.inboundMetricPayload, //using spread operator to initialize object with existing props
                    [event.target.name]: event.target.checked
                }
            })
        }
        else {
            this.setState({
                inboundMetricPayload: {
                    ...this.state.inboundMetricPayload, //using spread operator to initialize object with existing props
                    [event.target.name]: event.target.value,
                }
            })
        }
    }

    validateEditInboundFormField = (event, onSave = false) => {
        this.setState({ pageErrorMessage: null, pageSuccessMessage: null });
        if (onSave) {
            if (event.BizHrsInactivityTimeout === null || event.BizHrsInactivityTimeout === '' || Number.isNaN(event.BizHrsInactivityTimeout) || event.BizHrsInactivityTimeout <= 0) {
                this.setState({ pageErrorMessage: 'Business hours inactivity threshold frequency is required' });
                return false;
            }
            else if (event.Starthour === event.Endhour || event.Starthour === null || event.Endhour === null) {
                this.setState({ pageErrorMessage: 'Start hour and end hour are required and cannot be the same.' });
                return false;
            } else if (event.Starthour >= event.Endhour) {
                this.setState({ pageErrorMessage: 'Start hour should be less than end hour' });
                return false;
            }
            else if (event.DayOfWeek === null || event.DayOfWeek.length === 0) {
                this.setState({ pageErrorMessage: 'Atleast one weekday should be selected' });
                return false;
            }
            else if (event.OffHrsInactivityTimeout === null || event.OffHrsInactivityTimeout === '' || Number.isNaN(event.OffHrsInactivityTimeout) || event.OffHrsInactivityTimeout <= 0) {
                this.setState({ pageErrorMessage: 'Off-Hours inactivity threshold frequency is required' });
                return false;
            }
            else if (event.EditReason === null || event.EditReason === '') {
                this.setState({ pageErrorMessage: 'Edit Reason is required' });
                return false;
            }
            else if (event.EditReason.trim().length < global.COMMENT_BOX_MIN_LENGTH) {
                this.setState({ pageErrorMessage: 'Edit Reason should be atleast of ' + global.COMMENT_BOX_MIN_LENGTH + ' characters.', disableNotificationVisible: false })
            }
            else if (event.EditReason.trim().length > 0 || event.Comments.length > 0) {
                //HM-708 bug fix
                var onlyValidEditReasonCharacters = /^[^'"]*$/.test(event.EditReason.trim());
                var onlyCommentsCharacters = /^[^'"]*$/.test(event.Comments);
                if (!onlyValidEditReasonCharacters || !onlyCommentsCharacters) {
                    this.setState({ pageErrorMessage: "Action Comments/Edit Reason should not contain single (') or double (\") quotes.", disableNotificationVisible: false })
                }
                else {
                    this.setState({ pageErrorMessage: null, pageSuccessMessage: null });
                    this.onSaveInboundDetails();
                }
            }
        }
    }

    formatSeconds = (totalseconds) => {
        if (totalseconds >= 0) {
            var day = 86400;
            var hour = 3600;
            var minute = 60;
            var daysout = Math.floor(totalseconds / day);
            var hoursout = Math.floor((totalseconds - daysout * day) / hour);
            var minutesout = Math.floor((totalseconds - daysout * day - hoursout * hour) / minute);
            var secondsout = Math.floor(totalseconds - daysout * day - hoursout * hour - minutesout * minute);
            return daysout + "d " + hoursout + "h " + minutesout + "m " + secondsout + "s"
        }
        else
            return "0d 0h 0m 0s"
    }

    onSaveInboundDetails = () => {
        this.setState({ hideSpinner: false, actionCommentPanelCollasped: false })
        let requestBody = JSON.stringify(this.state.inboundMetricPayload)
        this.inboundActivityService.editInboundDataById(this.props.match.params.id, this.props.msalContext, requestBody).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.' });
                } else if (d.status === 200) {
                    this.setState({ pageErrorMessage: null, pageSuccessMessage: null })
                    if (this._isIssueDetailsMounted) {
                        this.setState({ inboundMetricDetails: d.body, hideSpinner: true, showInboundMetricUpdateLogs: false, pageSuccessMessage: 'Changes saved successfully.' });
                        this.clearInboundMetricFields();
                    }
                }
            }
        ).catch(e => {
            this.setState({ hideSpinner: true, pageErrorMessage: 'Something went wrong !!!' })
            console.log(e)
        });
    }

    clearInboundMetricFields = () => {
        this.setState({
            inboundMetricPayload: {
                Id: 0,
                System: null,
                Instance: null,
                Namespace: null,
                TimeCollected: null,
                InterfaceName: null,
                Priority: 0,
                NumMessages: 0,
                LastInboundTimeStamp: null,
                CurrentFrequencyInSeconds: 0,
                CurrentFrequency: null,
                InactivityTimeout: 0,
                ExpectedFrequency: null,
                IsBackloadService: false,
                Decommissioned: false,
                Comments: null,
                LastReviewedBy: null,
                LastReviewedDateTime: null,
                IsReviewed: false,
                IsAnomaly: false,
                EditReason: '',
            },
            EditInboundVisible: false,
            pageSuccessMessage: null,
            pageErrorMessage: null
        });
    }

    saveFooter = (
        <div>
            <Button label='Save' onClick={() => this.validateEditInboundFormField(this.state.inboundMetricPayload, true)} />
        </div>
    );

    reviewedBodyTemplate = (rowData) => {
        let body = ""
        if (rowData.IsReviewed) {
            body = <i className='pi pi-check-circle'></i>;
        } else if (rowData.CurrentFrequencyInSeconds > rowData.InactivityTimeout) {
            body = <i className='pi pi-times-circle'></i>;
        }
        return body;
    }

    backloadBodyTemplate = (rowData) => {
        let body = ""
        if (rowData.IsBackloadService) {
            body = <i className='pi pi-check-circle'></i>;
        } else {
            body = <i className='pi pi-times-circle'></i>;
        }
        return body;
    }

    isAnomalyTemplate = (rowData) => {
        //HDO-5544 - Message Volume Anomaly UI
        let body = ""
        if (rowData.IsAnomaly) {
            body = <i className='pi pi-exclamation-triangle'></i>;
        }
        return body;
    }

    showAlertMessage = (severity, alertMsg) => {
        this.alertMsg.showAlert(severity, alertMsg);
    }

    render() {
        let showButtons, actionCommentsText;
        if (this.state.hideSpinner) {
            if (this.state.inboundMetricDetails.length > 0) {
                if (this.state.inboundMetricDetails[0].Comments) {
                    actionCommentsText = this.state.inboundMetricDetails[0].Comments
                }
                else {
                    actionCommentsText = "<i>Nothing has been specified....</i>"
                }
            }
            //HDO-8090 - getRoleId() to check and only show edit button to admin users 
            showButtons = <div>
                <Button label='Back' icon='pi pi-arrow-left' onClick={() => this.props.history.push('/monitor/inboundmetric')} /> &nbsp;
                {this.getRoleId() === 1 ? <><Button label='Edit' icon='pi pi-user-edit' onClick={() => this.getMetricThresholdByLatestId()} /> &nbsp;</>
                    : <></>}
                <Button label='History' icon='pi pi-history' onClick={() => this.handleViewHistoryChange()} />
            </div>
        }
        return (
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <div className='InboundMetricDetailscontainer'>

                    <BreadCrumbComponent {...this.props} />
                    <AlertMessage ref={instance => { this.alertMsg = instance }} />

                    {this.state.pageErrorMessage ? this.showAlertMessage(MessageSeverity.ERROR, this.state.pageErrorMessage) : <></>}
                    {this.state.pageSuccessMessage ? this.showAlertMessage(MessageSeverity.SUCCESS, this.state.pageSuccessMessage) : <></>}

                    <div hidden={this.state.hideSpinner}>
                        <Spinner />
                    </div>

                    <header className="page-header">
                        <div className="page-header-title">INBOUND COMPONENT DETAILS</div>
                    </header>

                    <DataTable value={this.state.inboundMetricDetails}
                        selectionMode="single"
                        autoLayout={true}
                        editable="true"
                        editMode="cell"
                        showGridlines={true}
                    >
                        {/* <Column field="Id" header="#ID" style={{ textAlign: 'left', width: '60px' }} /> */}
                        <Column field="IsReviewed" header="Reviewed" dataType="boolean" style={{ textAlign: 'center', width: '4rem' }} body={this.reviewedBodyTemplate} />
                        <Column field="System" header='System' style={{ textAlign: 'left' }} />
                        <Column field="Instance" header='Instance' style={{ textAlign: 'left', width: '100px' }} />
                        <Column field="Namespace" header='Namespace' style={{ textAlign: 'left', width: '100px' }} />
                        <Column field="InterfaceName" header='Interface Name' style={{ textAlign: 'left', width: '100px' }} />
                        <Column field="Priority" header='Priority' style={{ textAlign: 'left', width: '100px' }} />
                        <Column field="TimeCollectedDisplay" header="Time Collected (EST)" style={{ textAlign: 'left', minwidth: '250px' }} />
                        <Column field="LastInboundTimeStampDisplay" header="Last Inbound (EST)" style={{ textAlign: 'left', minwidth: '250px' }} />
                        <Column field="CurrentFrequency" header="No Activity Since" style={{ textAlign: 'left', width: '130px' }} />
                        <Column field="ExpectedFrequency" header="Expected Frequency" style={{ textAlign: 'left', width: '100px' }} />
                        <Column field="IsBackloadService" header="Backload" dataType="boolean" style={{ textAlign: 'center', width: '4rem' }} body={this.backloadBodyTemplate} />
                        <Column field="IsAnomaly" header="Anomaly Alert" dataType="boolean" style={{ textAlign: 'center', width: '111px' }} body={this.isAnomalyTemplate} />
                    </DataTable> <br />

                    <Accordion activeIndex={0}>
                        <AccordionTab header="Action Comments" headerStyle={{ textAlign: 'left' }}>
                            < div className='action-comments' dangerouslySetInnerHTML={{ __html: actionCommentsText }}></div >
                        </AccordionTab>
                    </Accordion> <br />

                    <center>{showButtons}</center><br />

                    <div className="inboundMetricsUpdateLogs" style={{ display: this.state.showInboundMetricUpdateLogs && this.state.inboundMetricUpdateLogs.length ? "block" : "none" }}>
                        <DataTable value={this.state.inboundMetricUpdateLogs}
                            selectionMode="single"
                            autoLayout={true}
                            rowClassName={this.rowMirrorStyle}
                            paginator={this.state.showpagination}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50, 100]}
                            editable="true"
                            editMode="cell"
                            showGridlines={true}
                        >
                            <Column
                                field="IsReviewed"
                                header="Reviewed"
                                dataType="boolean" style={{ textAlign: 'center', width: '4rem' }} body={this.reviewedBodyTemplate} />
                            <Column
                                field="DisplayTimestamp"
                                header="DateTime (EST)"
                                style={{ textAlign: 'left' }} />
                            <Column
                                field="UpdatedBy"
                                header="Updated By"
                                style={{ textAlign: 'left' }} />
                            <Column
                                field="ActionComments"
                                header="Action Comments"
                                style={{ textAlign: 'left' }} />
                            <Column
                                field="Comments"
                                header="Edit Reason"
                                style={{ textAlign: 'left' }} />
                        </DataTable>
                        <br />
                    </div>

                    <Dialog header='Edit Inbound Details' footer={this.saveFooter} width='750px'
                        visible={this.state.EditInboundVisible} modal={true}
                        onHide={() => this.setState({ pageSuccessMessage: null, pageErrorMessage: null, EditInboundVisible: false })} maximizable={false}>
                        <div>
                            <table className='w-100'>
                                <tbody>
                                    <tr>
                                        <td colSpan={1}>
                                            <Checkbox name='IsReviewed' inputId="cb1" value="Active" onChange={this.handleInputChange} checked={this.state.inboundMetricPayload.IsReviewed}></Checkbox>&nbsp;
                                            <label htmlFor="cb1" className="p-checkbox-label d-inline">Reviewed</label>
                                        </td>
                                        <td colSpan={1}>
                                            <Checkbox name='IsBackloadService' inputId="cb1" value="Active" onChange={this.handleInputChange} checked={this.state.inboundMetricPayload.IsBackloadService}></Checkbox>&nbsp;
                                            <label htmlFor="cb1" className="p-checkbox-label d-inline">Backload Service</label>
                                        </td>
                                        <td colSpan={1}>
                                            <Checkbox name='Decommissioned' inputId="cb1" value="Active" onChange={this.handleInputChange} checked={this.state.inboundMetricPayload.Decommissioned}></Checkbox>&nbsp;
                                            <label htmlFor="cb1" className="p-checkbox-label d-inline">Decommissioned</label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4}>
                                            <label className='required-field'><b>Business-Hours</b></label>
                                            <div name="businessHours" className="card">
                                                <table>
                                                    <td>
                                                        <label>Threshold (Seconds) - {this.state.inboundMetricPayload.BizHoursFrequency}</label>
                                                        <InputText type='text' name='BizHrsInactivityTimeout' value={this.state.inboundMetricPayload.BizHrsInactivityTimeout || 0}
                                                            onChange={this.handleInputChange} onBlur={this.validateEditInboundFormField} />
                                                    </td>
                                                    <td>
                                                        <label>Start hour</label>
                                                        <Dropdown
                                                            id="number-dropdown"
                                                            value={this.state.inboundMetricPayload.Starthour}
                                                            onChange={(e) => this.setState({ inboundMetricPayload: { ...this.state.inboundMetricPayload, Starthour: e.value }, pageErrorMessage: null, pageSuccessMessage: null })}
                                                            options={this.state.hourValues}
                                                            placeholder="-- Select --"
                                                            className="w-full"
                                                        />
                                                    </td>
                                                    <td>
                                                        <label>End hour</label>
                                                        <Dropdown
                                                            id="number-dropdown"
                                                            value={this.state.inboundMetricPayload.Endhour}
                                                            onChange={(e) => this.setState({ inboundMetricPayload: { ...this.state.inboundMetricPayload, Endhour: e.value }, pageErrorMessage: null, pageSuccessMessage: null })}
                                                            options={this.state.hourValues}
                                                            placeholder="-- Select --"
                                                            className="w-full"
                                                            showClear={false}
                                                        />
                                                    </td>
                                                    <td>
                                                        <label>DayOfWeek</label>
                                                        <MultiSelect
                                                            id="number-dropdown"
                                                            value={this.state.inboundMetricPayload.DayOfWeek}
                                                            onChange={(e) => this.setState({ inboundMetricPayload: { ...this.state.inboundMetricPayload, DayOfWeek: e.value }, pageErrorMessage: null, pageSuccessMessage: null })}
                                                            options={this.state.weekdayValues}
                                                            placeholder="-- Select --"
                                                            className="w-full"
                                                        />
                                                    </td>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label className='required-field'><b>Off-Hours</b></label>
                                            <div name="offHours" className="card">
                                                <table border={0}>
                                                    <td>
                                                        <label>Threshold (Seconds) - {this.state.inboundMetricPayload.OffHoursFrequency}</label>
                                                        <InputText type='text' name='OffHrsInactivityTimeout' value={this.state.inboundMetricPayload.OffHrsInactivityTimeout || 0}
                                                            onChange={this.handleInputChange} onBlur={this.validateEditInboundFormField} />
                                                    </td>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4}>
                                            <label><b>Action Comments</b>
                                                &nbsp;<Tooltip target=".custom-target-icon" />
                                                <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge" data-pr-tooltip="Use HTML syntax for decorated text" data-pr-position="right" data-pr-at="right+5 top" data-pr-my="left center-2" style={{ fontSize: '1rem', cursor: 'pointer' }}></i>
                                            </label>
                                            <InputTextarea type='text' name='Comments' rows="5" cols="160" value={this.state.inboundMetricPayload.Comments}
                                                onChange={this.handleInputChange} onBlur={this.validateEditInboundFormField} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4}>
                                            <label className='required-field'><b>Edit Reason</b>
                                                &nbsp;<Tooltip target=".custom-target-icon" />
                                                <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge" data-pr-tooltip={'Edit Reason should be atleast of ' + global.COMMENT_BOX_MIN_LENGTH + ' characters'} data-pr-position="right" data-pr-at="right+5 top" data-pr-my="left center-2" style={{ fontSize: '1rem', cursor: 'pointer' }}></i>
                                            </label>
                                            <InputTextarea type='text' name='EditReason' rows="5" cols="160" value={this.state.inboundMetricPayload.EditReason}
                                                onChange={this.handleInputChange} onBlur={this.validateEditInboundFormField} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            {this.state.pageErrorMessage ? this.showAlertMessage(MessageSeverity.ERROR, this.state.pageErrorMessage) : <></>}
                        </div>
                    </Dialog>
                </div>
            </MsalAuthenticationTemplate >
        )
    }
}

const WrappedInboundDetailsComponent = withMsal(InboundDetailsComponent);
export default withAITracking(reactPlugin, WrappedInboundDetailsComponent);
